module.exports = __webpack_public_path__ + "img/story.759aba3e.png";